import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { clearError } from 'src/tools/helper';
import { EnumProductType, EnumStatus } from 'src/types/common/product';
import { getProduct } from '@/src/request/product/product';
import {
  variantProductCheck,
  productInfoCheck,
  settleData,
  convertDatafromServer,
} from '../data';
import { variantsAfterOptionsHasChanged } from './tools';
import { ProductItem } from 'src/types/common/product';
import { isSameType } from '../../tools/commonDataCheck';
import { msg } from 'src/tools/message';
import {
  submitProductThunk,
  activateProductThunk,
  draftProductThunk,
  archiveProductThunk,
  duplicateProduct,
} from '../../tools/commonRequests';
import { scroll } from 'src/tools/helper';
const defaultState = {
  hasModified: false,
  dataValid: false,
  loaded: false,
  storeUuid: '1',
  status: EnumStatus.Draft,

  options: [],
  brands: [{ name: '1', uuid: '22' }],

  productInfo: {
    name: '',

    remarks: '',

    brand: {},
  },
  tags: {
    tags: [],
  },
  variants: [],
  variantsEmptyError: false,
  productType: EnumProductType.Variant,
  inventoryUuid: null,
  uuid: null,
};
export const fetchProduct = createAsyncThunk(
  'fetchVariantProduct',
  async (uuid: string, thunkAPI) => {
    const response = await getProduct(uuid);
    return response;
  },
);

const VariantProductSlice = createSlice({
  name: 'variantProduct',
  initialState: defaultState,
  reducers: {
    setOptions(state, action) {
      state.hasModified = true;
      const { options } = action.payload;
      state.options = options;

      state.variants = variantsAfterOptionsHasChanged(options, state.variants);
    },
    addBrands(state, action) {
      state.brands = [...state.brands, action.payload];
      state.hasModified = true;
    },
    setProductInfoData(state, action) {
      state.productInfo = {
        ...state.productInfo,
        ...clearError(action.payload),
      };
      state.hasModified = true;
    },
    setTags(state, action) {
      state.tags = { ...state.tags, ...clearError(action.payload) };
      state.hasModified = true;
    },
    setVariantsProduct(state, action) {
      state.hasModified = true;
      const { index, prod = {} } = action.payload;
      const _p = (state.variants[index] || {}).product;
      (state.variants[index] || {}).product = { ..._p, ...clearError(prod) };
    },
    addVariantProduct(state, action) {
      state.hasModified = true;
      state.variantsEmptyError = false;
      state.variants = action.payload;
    },
    deleteVariantProduct(state, action) {
      state.hasModified = true;
      state.variants.splice(action.payload, 1);
    },
    setVariantsValues(state, action) {
      state.hasModified = true;
      const { id, text, index } = action.payload;
      const _preValue = (state.variants[index] || {}).values[id] || {};
      const obj = { ..._preValue, value: text };
      if (_preValue.valueError) {
        obj.valueError = false;
      }
      (state.variants[index] || {}).values[id] = obj;
    },

    emptyData(state) {
      state.hasModified = false;
      Object.keys(defaultState || {}).forEach((i) => {
        state[i] = defaultState[i];
      });
    },

    validate(state, action) {
      const check = (isDraft) => {
        const { productInfo } = state;
        const { flag: infoFlag, data: infoData } =
          productInfoCheck(productInfo);
        if (infoFlag || !infoData) {
          state.productInfo = infoData;
          state.dataValid = false;
          return;
        }
        const {
          flag: variantFlag,
          data: variantData,
          isEmpty,
        } = variantProductCheck(state.variants);
        if (variantFlag || !variantData) {
          state.variants = variantData;
          state.dataValid = false;
          return;
        }

        if (!isDraft && isEmpty) {
          state.dataValid = false;
          state.variantsEmptyError = true;
          scroll('ProductEditorVariantProductVariants', true);
          return;
        }
        state.dataValid = true;
        return;
      };
      const { savedType } = action.payload || {};
      const type = savedType || state.status;
      if (type === EnumStatus.Draft) {
        check(true);
      }
      if (type === EnumStatus.Active) {
        check(false);
      }
      if (type === EnumStatus.Archived) {
        state.dataValid = true;
      }
    },
  },
  extraReducers: (builder) => {
    function converProduct(state, action, isSave) {
      const hideMsg = action.payload.hideMsg;
      const product: ProductItem =
        action.payload.response || action.payload.product || action.payload;
      const { productType } = product;
      if (!hideMsg && productType === EnumProductType.Variant && isSave) {
        msg.success('saved successfully!');
      }
      if (productType === EnumProductType.Variant) {
        const updatedProduct = updateState(convertDatafromServer(product));
        Object.keys(updatedProduct || {}).forEach((i) => {
          state[i] = updatedProduct[i];
        });
      }
    }
    builder.addCase(fetchProduct.fulfilled, (state, action: any) => {
      // console.log(action);
      const { brands, product, inventoryUuid } = action.payload;

      //state.measurementUnits = measurementUnits;

      if (product) {
        converProduct(state, action, false);
      } else {
        state.loaded = true;
      }
      state.brands = brands;
      state.inventoryUuid = inventoryUuid;
    });
    builder.addCase(fetchProduct.rejected, (state, action) => {
      //state.status = EnumLoadingStatus.FAILED;
    });
    builder.addCase(submitProductThunk.fulfilled, (state, action) => {
      converProduct(state, action, true);
    });
    builder.addCase(submitProductThunk.rejected, (state, action) => {
      //state.status = EnumLoadingStatus.FAILED;
    });
    builder.addCase(activateProductThunk.fulfilled, (state, action) => {
      converProduct(state, action, true);
    });
    builder.addCase(draftProductThunk.fulfilled, (state, action) => {
      converProduct(state, action, true);
    });
    builder.addCase(archiveProductThunk.fulfilled, (state, action) => {
      converProduct(state, action, true);
    });
    builder.addCase(duplicateProduct, (state, action) => {
      const { productType, name, status } = action.payload;
      const isSame = isSameType(EnumProductType.Variant, productType);
      if (isSame) {
        state.uuid = null;
        state.productInfo.name = name;
        state.status = status;
      }
    });
  },
});
const updateState = (newProduct = {}) => {
  return { ...newProduct, variantsEmptyError: false };
};
export const getStateSelector = () => {
  return createSelector(
    [(state: any) => state.variantProduct],
    (variantProduct) => {
      return settleData(variantProduct);
    },
  );
};

export const {
  setProductInfoData,
  setVariantsValues,
  setTags,
  deleteVariantProduct,
  emptyData,
  addVariantProduct,
  setVariantsProduct,
  validate,
  setOptions,
  addBrands,
} = VariantProductSlice.actions;

export default VariantProductSlice.reducer;
